import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "33789a15-db2e-4f73-a8db-d9b964302ca4",
    content: "Has a maximum response along<br>the axis formed by the speakers ",
    options: {},
  },
  {
    id: "1a0af72c-1e9c-4f36-aa7c-465e14966d24",
    content: "Has a frequency independent directivity",
    options: {},
  },
  {
    id: "bbc40db1-cc5f-4d9e-bec8-d792cbc8b70b",
    content: "Has a nearfield behaviour up<br>to around 36 m at 1000 Hz",
    options: {},
  },
  {
    id: "54f598a3-df30-4eb7-824b-b570feb2c695",
    content: "Has a maximum response perpendicular<br>to the axis formed by the speakers ",
    options: {},
  },
  {
    id: "e7cd0f4e-7f17-4045-85e7-d1a3dafbb250",
    content: "Has a frequency dependent directivity",
    options: {},
  },
  {
    id: "67c27e15-5a71-4808-85b4-8018913daf6e",
    content: "Has a nearfield behaviour up<br>to around 12 m at 1000 Hz",
    options: {},
  },
];

export const task: Task = {
  id: "97f00034-7f06-4e88-873d-de05a4c1fc83",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "54f598a3-df30-4eb7-824b-b570feb2c695",
    "e7cd0f4e-7f17-4045-85e7-d1a3dafbb250",
    "67c27e15-5a71-4808-85b4-8018913daf6e",
  ],
};
